window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.button-open-modal').forEach((buttonOpenModal) => {
    const dialog = buttonOpenModal.parentElement.querySelector(
      '.complete-the-look__quick-add-dialog--mobile',
    );
    const bodyElement = document.querySelector('body');
    if (dialog) {
      buttonOpenModal.addEventListener('click', () => {
        dialog.classList.remove('hidden');
        bodyElement.classList.add('overflow-hidden');
        bodyElement.classList.add('complete-look-dialog-visible');
      });

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !dialog.classList.contains('hidden')) {
          dialog.classList.add('hidden');
          bodyElement.classList.remove('overflow-hidden');
          bodyElement.classList.remove('complete-look-dialog-visible');
        }
      });

      const buttonCloseModal = dialog.querySelector('.button-close-modal');
      if (buttonCloseModal) {
        buttonCloseModal.addEventListener('click', () => {
          dialog.classList.add('hidden');
          bodyElement.classList.remove('overflow-hidden');
          bodyElement.classList.remove('complete-look-dialog-visible');
        });
      }
    }
  });

  document.querySelectorAll('.complete-the-look fieldset').forEach(item => {
    item.querySelectorAll('input').forEach(i => {
      i.removeAttribute('checked');
    });
  });

});
